import type { Question } from '../types'

const countDistinctChoiceAnswers = (answer: string) => {
  return new Set(
    answer
      .split(',')
      .map(key => key.trim().toUpperCase())
      .filter(Boolean)
  ).size
}

export const getChoiceAnswerValidationMessage = (question: Pick<Question, 'type' | 'answer'>) => {
  const answerCount = countDistinctChoiceAnswers(question.answer)

  if (question.type === 'singleChoice' && answerCount !== 1) {
    return '单选题必须且只能有一个正确答案'
  }
  if (question.type === 'multipleChoice' && answerCount < 2) {
    return '多选题必须至少有两个正确答案'
  }
  return null
}
